import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";
import {
  MUTATION_ACCEPT_ROLLING_DEPOSIT_LIMIT,
  MUTATION_SET_NETT_DEPOSIT_LIMIT,
} from "../graphql/mutations";
import { useApolloClient } from "@apollo/client";

export const RollingLimitsDialog = ({
  showModal,
  skin,
  pages,
  showRollingLimitsDialog,
}) => {
  const { t } = useTranslation("");
  const apolloClient = useApolloClient();

  const handleProceed = async () => {
    try {
      const response = await apolloClient.mutate({
        mutation: MUTATION_ACCEPT_ROLLING_DEPOSIT_LIMIT,
      });
      if (response.data.setRollingDepositLimit.ok) {
        window.location.reload();
      }
    } catch (error) {
      console.log("error accepting rolling deposit limit", error);
    }
  };

  return (
    <StyledModal
      isOpen={showRollingLimitsDialog && showRollingLimitsDialog.displayPopup}
    >
      <StyledModalBody
        register
        dangerouslySetInnerHTML={{
          __html: t("label_rolling_limits"),
        }}
      ></StyledModalBody>
      <div style={{ textAlign: "center" }}>
        {showRollingLimitsDialog &&
          showRollingLimitsDialog.limitType +
            ": " +
            showRollingLimitsDialog.initialAmount / 100}
      </div>
      <StyledModalFooter>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={() => handleProceed()}
        >
          {t("label_understood")}
        </StyledButton>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={() => window.location.replace(pages["logout"])}
        >
          {t("label_cancel")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
